import React from 'react';
import { TaskDetail as TaskDetailComponent } from '../../components/Tasks';

const TaskDetail = () => {
  return <TaskDetailComponent />;
};

export default TaskDetail;


